import React from 'react';
import '../styles/components/_loading-spinner.scss';

/**
 * A custom loading spinner component with brand-appropriate styling
 * Used during page transitions and content loading
 */
const LoadingSpinner = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="mevedir-logo-spinner">
          <div className="logo-leaf logo-leaf-left"></div>
          <div className="logo-leaf logo-leaf-right"></div>
          <div className="logo-circle"></div>
        </div>
        <div className="loading-text">MEVEDIR</div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
